import React, { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { lightTheme } from './index';

// Global styles following Minimals.cc approach
const globalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      '*': {
        boxSizing: 'border-box',
      },
      html: {
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        WebkitOverflowScrolling: 'touch',
      },
      body: {
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        fontFamily: '"Public Sans", sans-serif',
        fontSize: '0.875rem',
        lineHeight: 1.5,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      '#root': {
        width: '100%',
        height: '100%',
      },
      input: {
        '&[type=number]': {
          MozAppearance: 'textfield',
          '&::-webkit-outer-spin-button': {
            margin: 0,
            WebkitAppearance: 'none',
          },
          '&::-webkit-inner-spin-button': {
            margin: 0,
            WebkitAppearance: 'none',
          },
        },
      },
      img: {
        display: 'block',
        maxWidth: '100%',
      },
      ul: {
        margin: 0,
        padding: 0,
      },
      // Scrollbar customization following Minimals.cc
      '::-webkit-scrollbar': {
        width: 8,
        height: 8,
      },
      '::-webkit-scrollbar-track': {
        background: '#F4F6F8',
      },
      '::-webkit-scrollbar-thumb': {
        background: '#C4CDD5',
        borderRadius: 4,
        '&:hover': {
          background: '#919EAB',
        },
      },
      // Selection colors
      '::selection': {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
      '::-moz-selection': {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    })}
  />
);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <MuiThemeProvider theme={lightTheme}>
      <CssBaseline />
      {globalStyles}
      {children}
    </MuiThemeProvider>
  );
}; 